var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2096,
    height: 2079,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -44,
    y: 757,
    width: 2096,
    height: 2079
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -44,
    y: 1238,
    width: 557,
    height: 559
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -44,
    y: 1238,
    width: 557,
    height: 559
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -44,
    y: 1238,
    width: 557,
    height: 559
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(44 -757)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -27.0002,
    y: 757,
    width: 2079,
    height: 2079,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M510.583 243.687 313.312 243.687 313.312 46.4167 243.687 46.4167 243.687 243.687 46.4167 243.687 46.4167 313.312 243.687 313.312 243.687 510.583 313.312 510.583 313.312 313.312 510.583 313.312Z",
    fill: "#203864",
    transform: "matrix(1 0 0 1 -44 1239)"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAis);
export default __webpack_public_path__ + "static/media/AIS.c79a7fed1b314b72698b5c0507b34ec5.svg";
export { ForwardRef as ReactComponent };